if (!customElements.get('mc-product-specs')) {
  customElements.define('mc-product-specs', class extends window.MCAnimatedDetails {
    connectedCallback() {
      this.info = this.closest('product-info');
      this.connectDisclosure('.mc-specs__body', '.mc-specs__content', 'mc-specs--closing');
      this.selection = this.querySelector('.mc-specs__selection');
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.info.sectionId) return;
        const source = data.html.getElementById(this.info.id)?.querySelector('mc-product-specs');
        if (source) this.update(source);
      });
      // The existing central product swap replaces main. Carry disclosure state
      // into its server-rendered successor before that successor is inserted.
      this.preserveState = html => {
        const successor = html.querySelector('mc-product-specs details');
        if (!successor) return;
        successor.open = this.expanded;
        if (this.expanded) {
          const height = this.body.getBoundingClientRect().height;
          successor.parentElement.dataset.previousHeight = String(height);
          successor.querySelector('.mc-specs__body').style.height = `${height}px`;
        }
      };
      this.info.addPreProcessCallback(this.preserveState);
      if (this.dataset.previousHeight) {
        const from = Number(this.dataset.previousHeight);
        delete this.dataset.previousHeight;
        this.swapFrame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.animateHeight(from, this.content.getBoundingClientRect().height);
          this.fadeContent();
        });
      }
    }

    update(source) {
      if (source.dataset.variantId === this.dataset.variantId) return;
      const from = this.details.open ? this.body.getBoundingClientRect().height : 0;
      this.finishMotion();
      if (this.expanded) this.body.style.height = `${from}px`;
      this.content.replaceChildren(...source.querySelector('.mc-specs__content').cloneNode(true).childNodes);
      const text = source.querySelector('.mc-specs__selection').textContent;
      if (this.selection.textContent !== text) this.selection.textContent = text;
      this.dataset.variantId = source.dataset.variantId;
      this.dataset.profile = source.dataset.profile;
      if (this.expanded) {
        const to = this.content.getBoundingClientRect().height;
        this.animateHeight(from, to);
        this.fadeContent();
      }
    }

    disconnectedCallback() {
      this.disconnectDisclosure();
      this.unsubscribe?.();
      cancelAnimationFrame(this.swapFrame);
      if (this.info) this.info.preProcessHtmlCallbacks = this.info.preProcessHtmlCallbacks.filter(callback => callback !== this.preserveState);
    }
  });
}
